import TableChart from '@mui/icons-material/TableChart';
import type { Extensions, SlashCommandItem } from '@provision/rich-text-editor';
import { TableKit } from '@tiptap/extension-table';
import { Placeholder } from '@tiptap/extensions';
import StarterKit from '@tiptap/starter-kit';

// The title is the page's only H1, and a legal page needs no code, quotes or dividers. The slash
// menu offers only what is loaded, except Heading 1, which it checks against the heading extension.
export function buildLegalDocumentExtensions({
  placeholder,
  slashExtension,
}: {
  placeholder: string;
  slashExtension: Extensions[number] | null;
}): Extensions {
  return [
    StarterKit.configure({
      heading: { levels: [2, 3] },
      code: false,
      codeBlock: false,
      blockquote: false,
      horizontalRule: false,
      link: {
        openOnClick: false,
        autolink: true,
        HTMLAttributes: { target: '_blank', rel: 'noopener noreferrer' },
      },
    }),
    TableKit.configure({ table: { resizable: false } }),
    Placeholder.configure({ placeholder }),
    ...(slashExtension ? [slashExtension] : []),
  ];
}

export const HIDDEN_HEADING_1: SlashCommandItem = {
  id: 'heading-1',
  title: 'Heading 1',
  isAvailable: () => false,
  run: () => undefined,
};

export const TABLE_SLASH_ITEM: SlashCommandItem = {
  id: 'table',
  title: 'Table',
  description: 'Insert a table with a header row.',
  icon: TableChart,
  keywords: ['table', 'grid', 'columns', 'rows'],
  group: 'Insert',
  run: ({ editor }) =>
    editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run(),
};
